import { createSlice } from "@reduxjs/toolkit";


const getCartItemFromLocalStorage = localStorage.getItem("cartItem") 
    ? JSON.parse(localStorage.getItem("cartItem")) 
    : null

const initialState = {
    cartItem: getCartItemFromLocalStorage,
    isLoading: false,
    isSuccess: false,
    isError: false,
    message: "",
}

export const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addToCart: (state, action) => {
            state.cartItem = action.payload
            localStorage.setItem("cartItem", JSON.stringify(state.cartItem))
        }
    },
})


export const { addToCart } = cartSlice.actions

export default cartSlice.reducer

